import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import Forwarder from './Forwarder';
import registerServiceWorker from './registerServiceWorker';

const forwarderDetails = () => {
	const match = window.location.search.match(/forward=(.*)/);
	return match && match[1];
};

const rootElement = document.getElementById('root');

const forwarderShortName = forwarderDetails();

if (forwarderShortName) {
	ReactDOM.render(<Forwarder shortName={forwarderShortName} />, rootElement);
} else {
	ReactDOM.render(<App />, rootElement);
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js